/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PlugZap2 = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m13 2-2 2.5h3L12 7" }],
    ["path", { d: "M10 14v-3" }],
    ["path", { d: "M14 14v-3" }],
    ["path", { d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z" }],
    ["path", { d: "M12 22v-3" }]
  ]
];

export { PlugZap2 as default };
//# sourceMappingURL=plug-zap-2.js.map
